module.exports = ".color-red {\n  color: red; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-main/components/restore-password/modal/restore-password-modal.component.scss
// module id = ./src/app/modules/common-main/components/restore-password/modal/restore-password-modal.component.scss
// module chunks = main